<template>
  <router-view />
</template>
<script>
export default { name: 'Recording' }
</script>
